module.exports = __webpack_public_path__ + "static/media/error.63b3fe49.svg";